__turbopack_context__.v({
  "className": "inter_b64e3d5e-module__Mla6za__className",
  "variable": "inter_b64e3d5e-module__Mla6za__variable",
});
